import styled from "styled-components";

const bp = { md: "768px" };

const c = {
  white: "#ffffff",
  ink: "rgba(0,0,0,0.90)",
  inkSoft: "rgba(0,0,0,0.62)",
  black: "#141414",
  gold: "#c9a227",
  goldLine: "rgba(201,162,39,0.42)",
  goldSoft: "rgba(201,162,39,0.14)",
  pink: "#ff77b4",
  pinkSoft: "rgba(255,119,180,0.12)",
};

export const Container = styled.div`
  min-height: calc(100vh + 60px);
  background: transparent;
  color: ${c.ink};

  display: flex;
  align-items: flex-start;
  justify-content: center;

  padding: 64px 18px 110px;

  @media (max-width: ${bp.md}) {
    padding: 28px 14px 90px;
  }
`;

export const Panel = styled.div`
  width: 100%;
  max-width: 520px;

  background: #ffffff;
  border-radius: 22px;

  border: 1px solid rgba(201, 162, 39, 0.45);
  box-shadow:
    0 0 0 4px rgba(201, 162, 39, 0.07),
    0 26px 70px rgba(0, 0, 0, 0.12);

  padding: 34px 30px 26px;
  position: relative;

  @media (max-width: ${bp.md}) {
    padding: 26px 18px 20px;
    border-radius: 20px;
  }

  * {
    box-sizing: border-box;
  }
  input:focus {
    border-color: rgba(201, 162, 39, 0.85) !important;
    box-shadow: 0 0 0 3px rgba(201, 162, 39, 0.12) !important;
  }
`;

export const Header = styled.div`
  text-align: center;
  margin-bottom: 18px;
`;

export const Title = styled.h1`
  margin: 6px 0 10px;
  font-family: "Cormorant Garamond", serif;
  font-weight: 650;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  font-size: 30px;
  color: rgba(0, 0, 0, 0.92);

  @media (max-width: ${bp.md}) {
    font-size: 28px;
  }
`;

export const Ornament = styled.div`
  position: relative;
  width: 260px;
  height: 14px;
  margin: 6px auto 14px;
`;

export const OrnLine = styled.span`
  position: absolute;
  left: 0;
  right: 0;
  top: 50%;
  height: 2px;
  transform: translateY(-50%);
  background: rgba(201, 162, 39, 0.42);
  border-radius: 999px;
`;

export const OrnDiamond = styled.span`
  position: absolute;
  left: 50%;
  top: 50%;
  width: 10px;
  height: 10px;
  transform: translate(-50%, -50%) rotate(45deg);
  background: #c9a227;
  border-radius: 2px;

  box-shadow:
    0 0 0 3px rgba(201, 162, 39, 0.14),
    0 1px 2px rgba(0, 0, 0, 0.12);
`;

export const Subtitle = styled.p`
  margin: 0;
  font-family: "Cormorant Garamond", serif;
  font-size: 16px;
  letter-spacing: 0.02em;
  color: ${c.inkSoft};
`;

export const Form = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 14px;
`;

export const Label = styled.label`
  display: block;
  font-size: 16px;
  font-weight: 900;
  font-family: "Cormorant Garamond", serif;
  letter-spacing: 0.16m;
  text-transform: uppercase;
  margin-bottom: 6px;
  color: #ff77b4;
`;

export const Input = styled.input`
  display: block;
  width: 100%;

  background: #ffffff;
  color: ${c.ink};

  border: 1px solid rgba(0, 0, 0, 0.18);
  border-radius: 14px;

  padding: 12px 14px;
  font-size: 15px;
  outline: none;

  transition:
    border-color 0.15s ease,
    box-shadow 0.15s ease;

  &:focus {
    border-color: rgba(201, 162, 39, 0.85);
    box-shadow: 0 0 0 3px rgba(201, 162, 39, 0.12);
  }
`;

export const InlineLink = styled.div`
  text-align: right;
  margin-top: 8px;

  a {
    font-family: "Cormorant Garamond", serif;
    font-size: 15px;
    color: rgba(0, 0, 0, 0.68);
    text-decoration: underline;
    text-underline-offset: 3px;

    &:hover {
      color: ${c.pink};
    }
  }
`;

export const SubmitButton = styled.button`
  width: 100%;
  margin-top: 6px;

  background: ${c.black};
  color: rgba(255, 255, 255, 0.94);

  font-family: "Cormorant Garamond", serif;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;

  padding: 12px 14px;
  border-radius: 14px;
  border: 1px solid rgba(201, 162, 39, 0.34);
  cursor: pointer;

  transition:
    transform 0.15s ease,
    border-color 0.15s ease,
    box-shadow 0.15s ease;

  &:hover {
    transform: translateY(-1px);
    border-color: rgba(255, 119, 180, 0.7);
    box-shadow: 0 12px 30px rgba(0, 0, 0, 0.14);
  }

  &:active {
    transform: translateY(0px);
    box-shadow: none;
  }
`;

export const MsgError = styled.div`
  margin-top: 6px;
  padding: 10px 12px;
  border-radius: 12px;
  border: 1px solid rgba(255, 0, 0, 0.18);
  background: rgba(255, 0, 0, 0.06);
  color: rgba(120, 0, 0, 0.9);
  font-weight: 700;
  text-align: center;
`;

export const MsgSuccess = styled.div`
  margin-top: 6px;
  padding: 10px 12px;
  border-radius: 12px;
  border: 1px solid rgba(0, 140, 70, 0.18);
  background: rgba(0, 140, 70, 0.06);
  color: rgba(0, 90, 45, 0.92);
  font-weight: 700;
  text-align: center;
`;

export const ResendBtn = styled.button`
  margin-top: 10px;
  background: transparent;
  border: 1px solid rgba(201, 162, 39, 0.45);
  color: rgba(0, 0, 0, 0.78);
  padding: 10px 12px;
  border-radius: 12px;
  cursor: pointer;

  font-family: "Cormorant Garamond", serif;
  font-weight: 700;
  letter-spacing: 0.06em;

  &:hover {
    border-color: rgba(255, 119, 180, 0.7);
    color: ${c.pink};
  }
`;
